!function () {
  "use strict";

  if (customElements.get("quantity-counter")) return;

  customElements.define(
    "quantity-counter",
    class extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.input = this.querySelector("input");
        this.changeEvent = new Event("change", { bubbles: true });
        this.buttonClickEvent = this.onButtonClick.bind(this);
        this.onQuantityChangeEvent = this.onQuantityChange.bind(this);
        this.lastAction = null;

        this.liveRegion = this.getLiveRegion();

        this.input.addEventListener("change", this.onQuantityChangeEvent);
        this.querySelectorAll("button").forEach((button) =>
          button.addEventListener("click", this.buttonClickEvent)
        );
      }

      getLiveRegion() {
        let liveRegion = this.querySelector("[data-quantity-announcer]");

        if (!liveRegion) {
          liveRegion = document.createElement("span");
          liveRegion.className = "visually-hidden";
          liveRegion.setAttribute("aria-live", "polite");
          liveRegion.setAttribute("aria-atomic", "true");
          liveRegion.setAttribute("data-quantity-announcer", "");
          this.appendChild(liveRegion);
        }

        return liveRegion;
      }

      announceQuantity() {
        if (!this.liveRegion) return;

        const strings = (window.theme && window.theme.strings) || {};
        const template =
          this.lastAction === "increase"
            ? strings.quantityIncreased || "Increased quantity to {quantity}"
            : this.lastAction === "decrease"
            ? strings.quantityDecreased || "Decreased quantity to {quantity}"
            : strings.quantityUpdated || "Quantity updated to {quantity}";

        const message = template.replace("{quantity}", this.input.value);

        this.lastAction = null;

        // Clear first so repeated identical values are still announced.
        // setTimeout (not requestAnimationFrame) so this still fires even
        // if the tab is backgrounded when the value changes.
        this.liveRegion.textContent = "";
        window.setTimeout(() => {
          this.liveRegion.textContent = message;
        }, 0);
      }

      onButtonClick(event) {
        event.preventDefault();

        const previousValue = this.input.value;
        const button =
          event.target.nodeName === "BUTTON" ? event.target : event.target.closest("button");

        if (button.name === "increase") this.input.stepUp();
        if (button.name === "decrease") this.input.stepDown();

        if (previousValue !== this.input.value) {
          this.lastAction = button.name;
          this.input.dispatchEvent(this.changeEvent);
        }
      }

      onQuantityChange() {
        if (this.input.name === "updates[]") this.updateCart();
        this.announceQuantity();
      }

      updateCart() {
        if (this.quantityValue !== "") {
          this.dispatchEvent(
            new CustomEvent("theme:cart:update", {
              bubbles: true,
              detail: { id: this.input.dataset.id, quantity: this.input.value },
            })
          );
        }
      }
    }
  );
}();
